import { useState } from 'react';
import ChooseRole from './ChooseRole';
import SignupRealestate from './signupRealestate/SignupRealestate';
import LoginModal from './LoginModal';
import SignupAgent from './signupAgent/SignupAgent';

export default function LoginFlow() {
  const [flow, setFlow] = useState({
    step: 1,
    role: '',
  });
  const renderStep = () => {
    switch (flow.step) {
      case 1:
        return <LoginModal setFlow={setFlow} />;
      case 2:
        return <ChooseRole setFlow={setFlow} />;
      case 3:
        if (flow.role === 'agent') {
          return <SignupAgent />;
        } else if (flow.role === 'realestate') {
          return <SignupRealestate />;
        }
      case 4:
        return <div>4</div>;
      default:
        return <LoginModal />;
    }
  };

  return <>{renderStep()}</>;
}
